import {PopperZIndexProvider} from "../../../../../misc/scroller/PopperZIndexProvider";
import {FetchContext, NumberCol, StringCol, Table} from "../../../../../misc/scroller/Table";
import {Opening} from "../../../../../api/Openings";
import {QuoteOpening} from "../../../../../api/QuoteOpenings";
import {api} from "../../../../../api/API";
import {getAll} from "../../../../logistics/routes/useGetAll";
import {useIsQuote} from "../../../quote/QuoteContainer";
import {useProjectId} from "../../ProjectName";
import {useAlternative} from "../../../quote/alternative/Alternative";
import {useSyncedRef} from "../../../../../misc/SyncedRef";
import {useState} from "react";
import {BulkAssignDegrees, BulkTarget} from "./BulkAssignDegrees";

export function ConfigureDegrees(props: {
    hardwareGroupId: number;
    isPair: boolean;
    opening?: number;
    onUpdate(): void;
}) {
    const isQuote = useIsQuote();
    const project = useProjectId();
    const alt = useAlternative();
    const isPair = props.isPair;
    const onUpdateRef = useSyncedRef(props.onUpdate);

    const [version, setVersion] = useState(0);

    const fetchList = async (ctx: FetchContext | null): Promise<(Opening|QuoteOpening)[]> => {
        if(isQuote) {
            const list = await getAll(ctx, offset => api.quoteOpenings.list({
                alternative: alt,
                project: project,
                hwGroup: props.hardwareGroupId,
                offset: offset,
                type: "for-hardware-group",
            }), {useLazy: true});

            if(props.opening) {
                return list.filter(o => o.id === props.opening);
            }

            return list;
        }

        const list = await getAll(ctx, offset => api.openings.list({
            project: project,
            hwGroup: props.hardwareGroupId,
            offset: offset,
            type: "for-hardware-group",
        }), {useLazy: true})

        if(props.opening) {
            return list.filter(o => o.id === props.opening);
        }

        return list;
    };

    const bulkAssign = async (input: {value: number | null, target: BulkTarget}) => {
        const list = await fetchList(null);
        const updated = list.map(o => Object.assign({}, o, {
            degreesOfOpeningActive: input.target === "inactive" ? o.degreesOfOpeningActive : input.value,
            degreesOfOpeningInactive: input.target === "active" ? o.degreesOfOpeningInactive : input.value,
        }));

        if(isQuote) {
            await api.quoteOpenings.upsertBulk(updated as QuoteOpening[]);
        } else {
            await api.openings.bulkUpsert(updated as Opening[]);
        }

        onUpdateRef.current();
        setVersion(v => v + 1);
    };

    return (
        <div style={{
            height: 400,
            width: 400,
            display: "flex",
            flexDirection: "column",
        }}>
            <PopperZIndexProvider value={1400}>
                <Table<Opening|QuoteOpening>
                    name="hw-degrees-of-opening"
                    columns={[
                        StringCol("Name", "name"),
                        NumberCol("Active", "degreesOfOpeningActive"),
                        isPair && NumberCol("In-Active", "degreesOfOpeningInactive"),
                    ]}

                    columnDeps={[isPair]}

                    onChange={input => {
                        onUpdateRef.current();

                        if(isQuote) {
                            return api.quoteOpenings.upsert(input as QuoteOpening);
                        }

                        return api.openings.upsert(input as Opening);
                    }}

                    fetch={fetchList}
                    fetchDeps={[alt, project, props.hardwareGroupId, props.opening, version]}

                />
            </PopperZIndexProvider>

            <BulkAssignDegrees isPair={isPair} onSubmit={bulkAssign} />
        </div>
    )
}